import './DashboardCard.css';
import dayjs from 'dayjs';
import { SkeletonText } from '../../../components/Skeleton/Skeleton';

const DRLatestDispatchCard = ({ colSpan = 1, rowSpan = 1, dashboardData = {} }) => {
  const { selectedDRResourceId, selectedDRResource, drHistoryLatestData, drHistoryLatestLoading, drHistoryLatestError, isLoading, drHistoryLatestSettlementData, drHistoryLatestSettlementLoading, drHistoryLatestSettlementError } = dashboardData;
  // DR 발령 상태 확인
  const getDispatchStatus = () => {
    if (!drHistoryLatestData) return null;

    const startTime = dayjs(drHistoryLatestData.date).format('YYYY-MM-DD') + ' ' + drHistoryLatestData.startTime;
    const endTime = dayjs(drHistoryLatestData.date).format('YYYY-MM-DD') + ' ' + drHistoryLatestData.endTime;
    const now = dayjs();
    const start = dayjs(startTime);
    const end = dayjs(endTime);

    if (now.isBefore(start)) {
      return { status: 'scheduled', label: '예정' };
    } else if (now.isAfter(end)) {
      return { status: 'ended', label: '종료' };
    } else {
      return { status: 'active', label: '발령중' };
    }
  };

  const dispatchStatus = getDispatchStatus();
  const duration = drHistoryLatestData?.timeSlots 
    ? (drHistoryLatestData.timeSlots.length / 4).toFixed(1) 
    : null;


  const drHistoryLatestSettlement = drHistoryLatestSettlementData?.Items?.find(item => item.DrResourceSysId === selectedDRResourceId);
  return (
    <div 
      className="dashboard-card flex flex-col justify-between gap-5" 
    >
      <div className='flex justify-between align-center'>
        <h3 className="text-b1-700 text-gray-700">최근 DR 발령일</h3>
        <div className='flex gap-2'>
          {isLoading || drHistoryLatestLoading ? (
            <SkeletonText width="100px" height="20px" />
          ) : drHistoryLatestData && (
            <div className='status-badge info'>
            <p className="text-c2-700">
                {dayjs(drHistoryLatestData?.date).format('YYYY-MM-DD')} {drHistoryLatestData?.startTime || '00:00'} - {drHistoryLatestData?.endTime || '00:00'}
              </p>
            </div>
          )}
        </div>
      </div>
      
      {isLoading || drHistoryLatestLoading ? (
        <div className="flex flex-col gap-3 flex-1">
          <SkeletonText width="100%" height="100%" />
        </div>
      ) : drHistoryLatestError ? (
        <div className="text-red-500 text-sm flex-1 flex items-center">
          데이터를 불러오는데 문제가 발생했습니다
        </div>
      ) : drHistoryLatestData ? (
        <div className="grid grid-cols-3 gap-2 flex-1 bg-secondary rounded p-5">
          <div className="flex flex-col gap-2 align-center">
            <p className="text-c2-700 text-gray-600">사용량(kWh)</p>
            <p className="text-b2-700 text-gray-700">{drHistoryLatestSettlement?.UsageValue || drHistoryLatestSettlement?.UsageValue === 0 ? drHistoryLatestSettlement?.UsageValue.toLocaleString() : '-'}</p>
          </div>
          <div className="flex flex-col gap-2 align-center">
            <p className="text-c2-700 text-gray-600">CBL값(kWh)</p>
            <p className="text-b2-700 text-gray-800">{drHistoryLatestSettlement?.CblValue || drHistoryLatestSettlement?.CblValue === 0 ? drHistoryLatestSettlement?.CblValue.toLocaleString() : '-'}</p>
          </div>
          <div className="flex flex-col gap-2 align-center">
            <p className="text-c2-700 text-gray-600">알고리즘/버전</p>
            <p className="text-b2-700 text-gray-800">{drHistoryLatestSettlement?.AppliedCblAlgorithm ? drHistoryLatestSettlement?.AppliedCblAlgorithm + ' / ' + drHistoryLatestSettlement?.AppliedCblAlgorithmVersion : '-'}</p>
          </div>
          <div className="flex flex-col gap-2 align-center">
            <p className="text-c2-700 text-gray-600">감축량(kWh)</p>
            <p className="text-b2-700 text-gray-800">{drHistoryLatestSettlement?.CblValue - drHistoryLatestSettlement?.UsageValue || drHistoryLatestSettlement?.CblValue - drHistoryLatestSettlement?.UsageValue === 0 ? (drHistoryLatestSettlement?.CblValue - drHistoryLatestSettlement?.UsageValue).toLocaleString() : '-'}</p>
          </div>
          <div className="flex flex-col gap-2 align-center">
            <p className="text-c2-700 text-gray-600">최소 정산금(원)</p>
            <p className="text-b2-700 text-gray-800">{drHistoryLatestSettlement?.MinSettlementAmount || drHistoryLatestSettlement?.MinSettlementAmount === 0 ? drHistoryLatestSettlement?.MinSettlementAmount.toLocaleString() : '-'}</p>
          </div>
          <div className="flex flex-col gap-2 align-center">
            <p className="text-c2-700 text-gray-600">최대 정산금(원)</p>
            <p className="text-b2-700 text-gray-800">{drHistoryLatestSettlement?.MaxSettlementAmount || drHistoryLatestSettlement?.MaxSettlementAmount === 0 ? drHistoryLatestSettlement?.MaxSettlementAmount.toLocaleString() : '-'}</p>
          </div>
        </div>
      ) : (
        <div className="text-gray-500 text-sm flex-1 flex items-center">
          발령 데이터가 없습니다
        </div>
      )}
    </div>
  );
};

export default DRLatestDispatchCard;
